import { Box, styled } from "@mui/material";

export const EditInstitutionWrapper = styled(Box)(({theme}) => {
    return {
        overflow: "hidden",
        "& .title-box": {
            marginBlockEnd: "var(--basic-margin)",
        },
        "& .fieldset-wrapper": {
            padding: "var(--basic-padding) calc(var(--basic-padding)/1.5)",
            border: "1px solid #D7D7D7",
            borderRadius: "20px",
            overflow: "hidden",
            marginBlockEnd: "var(--basic-margin)"
        },
        "& fieldset": {
            display: "flex",
            flexDirection: "column",
        },
        "& .file-box": {
            padding: "var(--basic-padding)",
            border: "1px solid #D7D7D7",
            borderRadius: "20px",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            gap: "calc(var(--flex-gap)/2)",
            "& .MuiInputBase-root": {
                boxShadow: "none",
            },
            [theme.breakpoints.up("laptop")]: {
                justifyContent: "center",
            }
        },
        "& .button-box": {
            marginBlockStart: "var(--basic-margin)"
        },
        "& .MuiInputBase-root": {
            border: "none",
            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
        },
        "& .institution-logo": {
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            objectFit: 'cover'
        },
    }
});
